import { RentReportingData, Subscriber } from "views/rent-reporting-id/types";
import { useAuthContext } from "providers/Auth";
import { Hide } from "shared/components";
import { SubscriptionDetails } from "./slices/SubscriptionDetails";
import { PersonalDetails } from "./slices/PersonalDetails";
import { RentReportingTable } from "./slices/RentReportingTable";

interface SubscriptionInfoProps {
  renter?: Subscriber;
}

export const SubscriptionInfo = ({ renter }: SubscriptionInfoProps) => {
  const { type } = useAuthContext();

  return (
    <>
      <div className="flex gap-4 flex-wrap md:flex-nowrap">
        <SubscriptionDetails renter={renter} />
        <PersonalDetails renter={renter} />
      </div>
      <Hide if={type.isSDK}>
        <RentReportingTable
          reportData={renter?.rent_reporting_data as RentReportingData[]}
        />
      </Hide>
    </>
  );
};
